import moment from 'moment';
import { currencyMask } from '~/utils/masks';

export const formatMoney = (value?: number): string =>
  value === undefined || value === null ? '-' : `R$ ${currencyMask(value)}`;

export const formatDate = (value?: string): string => {
  if (!value) return '-';

  const parsed = moment(
    value,
    ['YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601],
    true,
  );
  const date = parsed.isValid() ? parsed : moment(value);

  return date.isValid() ? date.format('DD/MM/YYYY') : value;
};
